module.exports = __webpack_public_path__ + "img/p2.47586a3d.png";